module.exports = __webpack_public_path__ + "static/media/Icon_cardboard_active.8ec9be78.svg";